export default {
  goodsStatusEnum: {
    '-1': 'Pagamento in sospeso',
    0: 'In fase di revisione',
    1: 'In attesa di conferma',
    2: 'Rimborso in sospeso',
    3: 'Restituzione merce',
    4: 'Cambio merce',
    5: 'Venditore spedito',
    6: 'Spedizione separata',
    7: 'Elaborazione differita',
    8: 'Consegnato',
    9: 'In fase di stoccaggio',
    10: 'Stoccato',
    11: 'Non valido',
    12: 'Distrutto',
    13: 'Scaduto',
    14: 'Conferma informazioni',
    15: 'Conferma acquisto',
    16: 'In attesa di procedura di reso',
    17: 'In attesa di procedura di cambio',
    18: 'Elaborazione reso',
    19: 'Elaborazione cambio',
    20: 'Restituito',
    21: 'Cambiato',
    22: 'Acquistato',
    23: 'In fase di elaborazione',
    24: 'Annullato',
    25: 'Ordine anomalo',
    26: 'In attesa di rimborso',
    27: 'In attesa di rispedizione',
    28: 'In fase di raccolta',
    29: 'Imballaggio completato',
    30: 'Spedito a livello internazionale',
    31: 'Ricevuto',
    32: "Pagamento dell'ordine rifiutato",
    33: 'Controllo rischi',
    34: 'Rimborso completato',
    35: 'Elenco ordini congelati',
    36: 'Pagamento di pre-sottoscrizione',
    37: 'In attesa di ritiro',
    38: 'Rimborso in corso',
    39: 'Merci rifiutate',
    40: 'Rifiuto completato',
    41: 'Eccezione: esaurito',
    42: 'Eccezione: disponibile',
    43: 'Reso annullato',
    44: 'Cambio annullato',
    45: 'Firmato e in attesa',
    46: 'Elaborazione degli ordini',
    47: 'Elaborazione ordine',
    48: 'Pagamento completato',
    49: 'Abbandonato',
    50: 'Completato',
    51: 'Reso in attesa di approvazione del venditore',
    52: 'Cambio in attesa di approvazione del venditore',
    53: 'Pacco reso non valido',
    54: 'Da generare',
    55: 'Elaborazione ordine',
    58: 'Merci in trasferimento',
  },
  appendStatusEnum: {
    0: 'In attesa',
    1: 'In elaborazione',
    2: 'Annullato',
    3: 'Completato',
    4: 'Restituito',
  },
  inviteStatusEnum: {
    0: 'Inattivo',
    1: 'Attivo',
  },
}
